import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import {Observable, take} from 'rxjs';
import {
  ActivationCodeReq,
  ContinueAsGuest,
  CouponsRes,
  LoginReq,
  LoginRes,
  LoginSocialReq,
  Pagable,
  Profile,
  RegisterReq,
  RegisterRes,
  UpdateProfileReq,
  VerifyActivationCodeReq,
} from '../../models';
import GoponRes from '@core/models/gopon-res.model';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private baseUrl = environment.API_BASE_URL + 'Account/';
  loginUrl = this.baseUrl + 'Login';
  loginWithSocialMediaUrl = this.baseUrl + 'LoginWithSocialMedia';
  continueAsGuestUrl = this.baseUrl + 'ContinueAsGuest';
  registerUrl = this.baseUrl + 'Register';
  verifyActivationCodeUrl = this.baseUrl + 'VerifyActivationCode';
  forgotPasswordByEmailUrl = this.baseUrl + 'ForgotPasswordByEmail';
  forgotPasswordByMobileUrl = this.baseUrl + 'ForgotPasswordByMobile';
  resetPasswordUrl = this.baseUrl + 'ResetPassword';
  sendActivationCodeUrl = this.baseUrl + 'SendActivationCode';
  getCustomerProfileUrl = this.baseUrl + 'GetCustomerProfile';
  updateCustomerProfileUrl = this.baseUrl + 'UpdateProfile';
  removeAccountUrl = this.baseUrl + 'RemoveAccount';
  changePasswordUrl = this.baseUrl + 'ChangePassword';
  getBranchPurchasedServiceCodesListUrl =
    this.baseUrl + 'GetBranchPurchasedServiceCodesList';
  getCenterPurchasedServiceCodeUrl =
    this.baseUrl + 'GetCenterPurchasedServiceCode';
  activateCenterPurchasedServiceCodeUrl =
    this.baseUrl + 'ActivateCenterPurchasedServiceCode';

  constructor(private readonly http: HttpClient) {}

  continueAsGuest(body: ContinueAsGuest): Observable<LoginRes> {
    return this.http
      .post<LoginRes>(this.continueAsGuestUrl, body)
      .pipe(take(1));
  }
  login(body: LoginReq): Observable<LoginRes> {
    return this.http.post<LoginRes>(this.loginUrl, body).pipe(take(1));
  }
  loginSocial(body: LoginSocialReq): Observable<LoginRes> {
    return this.http
      .post<LoginRes>(this.loginWithSocialMediaUrl, body)
      .pipe(take(1));
  }
  register(body: RegisterReq): Observable<RegisterRes> {
    return this.http.post<RegisterRes>(this.registerUrl, body).pipe(take(1));
  }
  verifyActivationCode(body: VerifyActivationCodeReq): Observable<LoginRes> {
    return this.http
      .post<LoginRes>(this.verifyActivationCodeUrl, body)
      .pipe(take(1));
  }
  forgotPasswordByEmail(email: string): Observable<RegisterRes> {
    return this.http
      .post<RegisterRes>(this.forgotPasswordByEmailUrl, { email })
      .pipe(take(1));
  }
  forgotPasswordByMobile(
    mobileCode: string,
    mobileNumber: string
  ): Observable<RegisterRes> {
    return this.http
      .post<RegisterRes>(this.forgotPasswordByMobileUrl, {
        mobileCode,
        mobileNumber,
      })
      .pipe(take(1));
  }
  resetPassword(password: string): Observable<GoponRes> {
    return this.http
      .put<GoponRes>(this.resetPasswordUrl, {
        password,
      })
      .pipe(take(1));
  }
  sendActivationCode(body: ActivationCodeReq): Observable<RegisterRes> {
    return this.http
      .post<RegisterRes>(this.sendActivationCodeUrl, body)
      .pipe(take(1));
  }
  getCustomerProfile(): Observable<Profile> {
    return this.http
      .get<Profile>(this.getCustomerProfileUrl)
      .pipe(take(1));
  }
  updateCustomerProfile(body: UpdateProfileReq): Observable<Profile> {
    return this.http
      .put<Profile>(this.updateCustomerProfileUrl, body)
      .pipe(take(1));
  }
  removeAccount(): Observable<RegisterRes> {
    return this.http
      .delete<RegisterRes>(this.removeAccountUrl)
      .pipe(take(1));
  }
  changePassword(body: {
    currentPassword: string;
    password: string;
  }): Observable<GoponRes> {
    return this.http.put<GoponRes>(this.changePasswordUrl, body).pipe(take(1));
  }
  getBranchPurchasedServiceCodesList(body: Pagable): Observable<CouponsRes> {
    return this.http
      .get<CouponsRes>(this.getBranchPurchasedServiceCodesListUrl, {
        params: body as any,
      })
      .pipe(take(1));
  }
  getCenterPurchasedServiceCode(
    serviceCouponCode: string
  ): Observable<CouponsRes> {
    return this.http
      .get<CouponsRes>(this.getCenterPurchasedServiceCodeUrl, {
        params: serviceCouponCode as any,
      })
  }
  activateCenterPurchasedServiceCode(
    serviceCouponCode: string
  ): Observable<CouponsRes> {
    return this.http
      .post<CouponsRes>(this.activateCenterPurchasedServiceCodeUrl, {
        serviceCouponCode,
      })
      .pipe(take(1));
  }
}
